import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import "./FilterText.css";
import "../../css/Icons.css";
import { selectUser } from "../../redux/features/appData";

type FilterTextProps = {
  text?: string;
  bouncems?: number;
  onFilterChange: any;
  style?: any;
};

export const FilterText = ({
  text = "",
  bouncems = 500,
  onFilterChange,
  style = undefined,
}: FilterTextProps) => {
  const dispatch = useDispatch();

  const storeUser = useSelector(selectUser);

  const [searchFilter, setSearchFilter] = useState<string>("");
  const [debouncedSearchFilter, setDebouncedSearchFilter] =
    useState<string>(text);

  useEffect(() => {
    setSearchFilter(text);
  }, []);

  useEffect(() => {
    onFilterChange(debouncedSearchFilter);
  }, [debouncedSearchFilter]);

  const handleSearchFilterChange = (e: any) => {
    setSearchFilter(e.target.value);
    debounceUpdate(e.target.value);
  };

  const handleDelete = () => {
    setSearchFilter("");
    debounceUpdate("");
  };

  const debounce = (func: any, delay: any) => {
    let timeoutId: any;
    return (...args: any) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debounceUpdate = debounce((value: string) => {
    setDebouncedSearchFilter(value);
  }, bouncems);

  //   console.log("[FilterText/main] search filter: ", search);

  return (
    <>
      {
        <div className="filter-text-search">
          <div className="filter-text-search-icon">
            <img className="icon-search" alt="" />
          </div>
          <div className="filter-text-search-input">
            <input
              value={searchFilter}
              onChange={handleSearchFilterChange}
              style={style ? style : {}}
              placeholder="Search..."
            />
          </div>
          <div className="filter-text-delete" onClick={handleDelete}>
            <img className="icon-close" alt="" />
          </div>
        </div>
      }
    </>
  );
};
